import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StepButton from '@material-ui/core/StepButton';
import { removeXSSAttacks } from "../common/helper";
import EmailStyle from "../styles/emailStyle";
import { FEATURE } from "../utils/feature";
import { SALESFORCE_NOT_CONFIGURED_MESSAGE } from "../constants/emails.constant";

const hasFeature = FEATURE();

class Email extends React.Component {
    state = { selectedRow: void 0 }
    componentDidMount() {
        let { GetEmail = () => {}, productInfo = {} } = this.props;
        if (hasFeature.IS_SALESFORCE_CONFIGURED && GetEmail) {
            GetEmail(productInfo);
        }
    }
    UNSAFE_componentWillUnmount() {
        let { ResetEmailTab } = this.props;
        ResetEmailTab && ResetEmailTab();
    }
    componentDidUpdate(prevProps) {
        let { GetEmail = () => {}, productInfo = {}, ResetEmailTab, isEmailSentToPatient } = this.props;
        if (!prevProps.isEmailSentToPatient && isEmailSentToPatient) {
            ResetEmailTab && ResetEmailTab();
            if (hasFeature.IS_SALESFORCE_CONFIGURED && GetEmail) {
                GetEmail(productInfo);
            }
        }
    }
    toggleMessage = (index) => {
        if (this.state.selectedRow === index) {
            this.setState({ selectedRow: void 0 });
        } else {
            this.setState({ selectedRow: index });
        }
    }

    getEmails = (data = []) => {
        let { classes } = this.props;
        if (!data.length) {
            return (
                <div id="email-empty-row" className={classes.emptyRow}>
                    <div className="flex align-items-center height-40">No emails for this patient</div>
                    {
                        !hasFeature.IS_SALESFORCE_CONFIGURED && (
                            <div className="flex align-items-center height-40 color-red-v1">{SALESFORCE_NOT_CONFIGURED_MESSAGE}</div>
                        )
                    }
                </div>
            )
        } else {
            return (
                data ? data.map((value, index) => {
                    let time = value.EntryDate ? `${value.EntryDate}` : null;
                    return (
                        <div className={`${classes.EmailRowWrapper} ${index % 2 === 0 ? classes.EmailOddRowWrapper : ""}`}>
                            <div className={classes.EmailRow}>
                                <div className={classes.iconSection}>
                                    <StepButton id={`stepButton`} onClick={_ => this.toggleMessage(index)} className={classes.expandIconStyle}>
                                        <ExpandMoreIcon className={`${classes.expanIcon} ${index === this.state.selectedRow ? classes.reverseExpanIcon : ""}`} viewBox={"6 6 12 14"} />
                                    </StepButton>
                                </div>
                                <div id="eamil-date-row" className={classes.dateRowStyle}>{time}</div>
                                <div id="eamil-to-row" title={value.RecipientName} className={classes.toRowStyle}><span className={classes.ellipsis}>{value.RecipientName}</span></div>
                                <div id="eamil-from-row" title={value.SenderName} className={classes.fromRowStyle}><span className={classes.ellipsis}>{value.SenderName}</span></div>
                                <div id="eamil-subject-row" title={value.Subject} className={classes.subjectRowStyle}><span className={classes.ellipsis}>{value.Subject}</span></div>
                            </div>
                            <div className={`${classes.EmailMessageRow} ${index !== this.state.selectedRow ? classes.EmailMessageHiddenRow : ""}`}>
                                <div className={classes.iconSection}>&nbsp;</div>
                                <div id="eamil-body-row" className={classes.messageRowStyle} dangerouslySetInnerHTML={{ __html: removeXSSAttacks(value.Message) }}></div>
                            </div>
                        </div>
                    )
                }) : null
            )
        }
    }

    render() {
        let { classes, loading, emailData = [] } = this.props;
        
        return (
            <div data-app="email-component-wrapper" className={classes.fixEmailHeaderWrapper}>
                <div className={`${classes.tableHeader} fixedEmailTitle`}>
                    <div className={classes.iconSection}>
                        &nbsp;
                        </div>
                    <div id="eamil-date-header" className={classes.dateSection}>
                        Date
                        </div>
                    <div id="eamil-to-header" className={classes.toSection}>
                        To
                        </div>
                    <div id="eamil-from-header" className={classes.fromSection}>
                        From
                        </div>
                    <div id="eamil-subject-header" className={classes.subjectSection}>
                        Subject
                        </div>
                </div>
                <div id="email-scroll-window" className={`${classes.emailWrapper}`}>
                    {loading ? null : this.getEmails(emailData)}
                </div>
            </div>
        )
    }
}


export default withStyles(EmailStyle)(Email);

